const SELECTORS = {
  swiperContainerMobile: '.for-mobile .recommendation-wrapper',
};

/**
 * @param Swiper
 */
const initProductSlider = (Swiper) => {
  const swiperContainer = document.querySelector(SELECTORS.swiperContainerMobile);
  const swiperOptions = {
    freeMode: true,
    slidesPerView: 'auto',
    spaceBetween: 20,
  };

  if (swiperContainer && Swiper) {
    // eslint-disable-next-line no-unused-vars
    const categorySwiper = new Swiper(swiperContainer, swiperOptions);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  window.LoadSwiper.then((module) => {
    initProductSlider(module.Swiper);
  });
});
